module.exports = __webpack_public_path__ + "76c92654105ee0901b45aba22f8b647a.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-52.png
// module id = 131
// module chunks = 0